<template>
    <div class="panel white_bg">
        <div class="inner paddingH16">

            <div v-if="dataItem">
                <article class="article" v-html="dataItem"></article>
            </div>

            <div class="marginT12">
                <router-link :to="{name:'agencyProductActivation'}" class="button block activationButton font14r">
                    去开通产品
                </router-link>
            </div>
        </div>

    </div><!-- end .module -->
</template>

<script>
import modulePart from '@comp/part/modulePart';

const config = {
    apiConfig : {
        get : {
            url : 'portal/about/get_Agreement',
            params : {
                code : 'agent_product_activation_intro'
            }
        }
    }
};

export default {
    name: "AgencyProductActivationPanel",
    extends : modulePart,
    components : {  },
    data () {
        return {
            apiConfig : config.apiConfig,

            // enableDataList : true,
            // autoLoadDataList : true,
            enableDataItem : true,
            // autoLoadDataItem : true,
        }
    },
    mounted() {
        this.loadDataItem();
    }
}
</script>

<style lang="scss" scoped>
.activationButton {
    width: 100%;
    height: 39px;
    line-height: 39px;
    padding: 0;
    border-radius: 25px;
    border: none 0;
    background-color: rgba(233, 157, 66, 1);
    color: white;
}
</style>
